// export const checkStatus=t=>{if(t.status>=200&&t.status<300)return t;if(500===t.status)return t.json().then(t=>{console.log(t);const r=(t||{}).error;throw new TypeError(r||"Server error")});if(401===t.status){throw{code:t.status,data:"Unathorized"}}return t.json().then(r=>{throw{code:t.status,data:r}})};export const parseJSON=t=>t;
export const checkStatus = response => {
    console.log('=response=checkstatus=',response)
    if (response.status >= 200 && response.status < 300) {
        return response
    }
    if (response.status === 500) {
        return response.json().then(errorData => {
            const message = (errorData || {}).error
            const error = new TypeError(message || 'Server error')
            throw error
        })
    }
    if (response.status === 401) {
        const error = {
            code: response.status,
            data: 'Unathorized'
        }
        throw error
    }
    return response.json().then(errorData => {
        const error = {
            code: response.status,
            data: errorData
        }
        throw error
    })
}

export const parseJSON = response => {
    console.log('==responseresponse=',response)
    if (response.status === 204 || response.status === 205) {
        return null
    }
    if (response.statusText === "Conflict" && response.status === 409) {
        return {httpStatus: response.status, message: response.data.data.messages.name}
    }
    if (response.statusText === "Bad Request" && response.status === 400) {
        return {httpStatus: response.status, message: response.data.data.messages.actionURL || response.data.data.messages.endDate || response.data.data.messages.mediaURL }
    }
    if (response.statusText === 'Unauthorized' && response.status === 401) {
        return {httpStatus: response.status, message: 'Authentication fails'}
    }
    const contentType = response.headers["content-type"]
    if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.data
    }
    return null
}